/**
 * Mobile Login Button — primary CTA on the pre-auth landing.
 *
 * Wraps the rider PrimaryButton + ButtonChevron primitive and dispatches the
 * OAuth login thunk. Lives as its own atom because it appears in multiple
 * compositions (landing form + callback retry).
 */

import type { FC } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import { login, selectIsLoading } from '../../store/slices/authSlice';
import {
  ButtonChevron,
  PrimaryButton,
} from '../../theme/surfacePrimitives';

interface MobileLoginButtonProps {
  disabled?: boolean;
  label?: string;
  loadingLabel?: string;
}

const MobileLoginButton: FC<MobileLoginButtonProps> = ({
  disabled,
  label = 'Sign in',
  loadingLabel = 'Signing in…',
}) => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(selectIsLoading);

  const handleLogin = () => {
    dispatch(login());
  };

  const blocked = disabled || isLoading;

  return (
    <PrimaryButton
      onClick={handleLogin}
      disabled={blocked}
      $disabled={blocked}
      aria-label={isLoading ? loadingLabel : label}
    >
      <span>{isLoading ? loadingLabel : label}</span>
      <ButtonChevron aria-hidden>→</ButtonChevron>
    </PrimaryButton>
  );
};

export default MobileLoginButton;
